import { useState, useEffect } from "react"
import { useParams, Link } from "react-router-dom"
import AmendAppointmentForm from "../components/AmendAppointmentForm"
import { getAppointmentByToken } from "../lib/publicQueries"
import "./ServiceRequestPage.css"

function AmendAppointmentPage() {
  const { token } = useParams()
  const [appointment, setAppointment] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchAppointment() {
      if (!token) {
        setError("No amendment token provided.")
        setLoading(false)
        return
      }

      try {
        const { data, error: fetchError } = await getAppointmentByToken(token)

        if (fetchError) {
          setError("Unable to load your appointment. Please try again later.")
          return
        }

        if (!data) {
          setError("This link is no longer valid. The appointment may have been cancelled or the link has expired.")
          return
        }

        if (data.status === "rejected" || data.status === "cancelled") {
          setError("This appointment has been " + data.status + " and can no longer be managed.")
          return
        }

        setAppointment(data)
      } catch (err) {
        console.error("Error loading appointment:", err)
        setError("An unexpected error occurred. Please try again later.")
      } finally {
        setLoading(false)
      }
    }

    fetchAppointment()
  }, [token])

  if (loading) {
    return (
      <div className="prescription-page">
        <div className="page-header">
          <h1>Manage Your Booking</h1>
          <p>Loading your appointment details...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="prescription-page">
        <Link to="/" className="back-link">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Home
        </Link>
        <div className="page-header">
          <h1>Manage Your Booking</h1>
        </div>
        <div className="form-container">
          <div className="error-message">
            <p>{error}</p>
          </div>
          <p style={{ textAlign: "center", marginTop: "16px" }}>
            If you need assistance, please contact us at <strong>01772 123456</strong> or visit the pharmacy.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="prescription-page">
      <Link to="/" className="back-link">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Back to Home
      </Link>

      <div className="page-header">
        <h1>Manage Your Booking</h1>
        <p>
          Use the form below to amend or cancel your appointment.
          After amending, your appointment will need to be re-confirmed by the pharmacy.
        </p>
      </div>

      <div className="form-container">
        <AmendAppointmentForm appointment={appointment} token={token} />
      </div>
    </div>
  )
}

export default AmendAppointmentPage
